/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useInfiniteQuery, useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  BulkProduct,
  BulkProductCreate,
  BulkProductRead,
  CatalogProductUsageCheck,
  GetBulkProductsParams,
  HTTPValidationError,
  PageBulkProductRead,
} from "./fastAPI.schemas";

import { customInstance } from "../../axios";
import type { ErrorType } from "../../axios";

/**
 * Route to create a new bulk_product.
 * @summary Create Bulk Product
 */
export const createBulkProduct = (
  bulkProductCreate: BulkProductCreate,
  signal?: AbortSignal,
) => {
  return customInstance<number>({
    url: `/api/bulk_product/`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: bulkProductCreate,
    signal,
  });
};

export const getCreateBulkProductMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createBulkProduct>>,
    TError,
    { data: BulkProductCreate },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createBulkProduct>>,
  TError,
  { data: BulkProductCreate },
  TContext
> => {
  const mutationKey = ["createBulkProduct"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createBulkProduct>>,
    { data: BulkProductCreate }
  > = (props) => {
    const { data } = props ?? {};

    return createBulkProduct(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateBulkProductMutationResult = NonNullable<
  Awaited<ReturnType<typeof createBulkProduct>>
>;
export type CreateBulkProductMutationBody = BulkProductCreate;
export type CreateBulkProductMutationError =
  ErrorType<void | HTTPValidationError>;

/**
 * @summary Create Bulk Product
 */
export const useCreateBulkProduct = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createBulkProduct>>,
      TError,
      { data: BulkProductCreate },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createBulkProduct>>,
  TError,
  { data: BulkProductCreate },
  TContext
> => {
  const mutationOptions = getCreateBulkProductMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Route to get many bulk_products.

Results are paginated.
 * @summary Get Bulk Products
 */
export const getBulkProducts = (
  params?: GetBulkProductsParams,
  signal?: AbortSignal,
) => {
  return customInstance<PageBulkProductRead>({
    url: `/api/bulk_product/`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetBulkProductsInfiniteQueryKey = (
  params?: GetBulkProductsParams,
) => {
  return [
    "infinite",
    "api",
    "bulk_product",
    ...(params ? [params] : []),
  ] as const;
};

export const getGetBulkProductsQueryKey = (params?: GetBulkProductsParams) => {
  return ["api", "bulk_product", ...(params ? [params] : [])] as const;
};

export const getGetBulkProductsInfiniteQueryOptions = <
  TData = InfiniteData<
    Awaited<ReturnType<typeof getBulkProducts>>,
    GetBulkProductsParams["page"]
  >,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetBulkProductsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getBulkProducts>>,
        TError,
        TData,
        QueryKey,
        GetBulkProductsParams["page"]
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetBulkProductsInfiniteQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBulkProducts>>,
    QueryKey,
    GetBulkProductsParams["page"]
  > = ({ signal, pageParam }) =>
    getBulkProducts({ ...params, page: pageParam || params?.["page"] }, signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getBulkProducts>>,
    TError,
    TData,
    QueryKey,
    GetBulkProductsParams["page"]
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetBulkProductsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBulkProducts>>
>;
export type GetBulkProductsInfiniteQueryError =
  ErrorType<void | HTTPValidationError>;

export function useGetBulkProductsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getBulkProducts>>,
    GetBulkProductsParams["page"]
  >,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params: undefined | GetBulkProductsParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getBulkProducts>>,
        TError,
        TData,
        QueryKey,
        GetBulkProductsParams["page"]
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBulkProducts>>,
          TError,
          Awaited<ReturnType<typeof getBulkProducts>>,
          QueryKey
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetBulkProductsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getBulkProducts>>,
    GetBulkProductsParams["page"]
  >,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetBulkProductsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getBulkProducts>>,
        TError,
        TData,
        QueryKey,
        GetBulkProductsParams["page"]
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBulkProducts>>,
          TError,
          Awaited<ReturnType<typeof getBulkProducts>>,
          QueryKey
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetBulkProductsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getBulkProducts>>,
    GetBulkProductsParams["page"]
  >,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetBulkProductsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getBulkProducts>>,
        TError,
        TData,
        QueryKey,
        GetBulkProductsParams["page"]
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Bulk Products
 */

export function useGetBulkProductsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getBulkProducts>>,
    GetBulkProductsParams["page"]
  >,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetBulkProductsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getBulkProducts>>,
        TError,
        TData,
        QueryKey,
        GetBulkProductsParams["page"]
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetBulkProductsInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetBulkProductsQueryOptions = <
  TData = Awaited<ReturnType<typeof getBulkProducts>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetBulkProductsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBulkProducts>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetBulkProductsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getBulkProducts>>> = ({
    signal,
  }) => getBulkProducts(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getBulkProducts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetBulkProductsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBulkProducts>>
>;
export type GetBulkProductsQueryError = ErrorType<void | HTTPValidationError>;

export function useGetBulkProducts<
  TData = Awaited<ReturnType<typeof getBulkProducts>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params: undefined | GetBulkProductsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBulkProducts>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBulkProducts>>,
          TError,
          Awaited<ReturnType<typeof getBulkProducts>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetBulkProducts<
  TData = Awaited<ReturnType<typeof getBulkProducts>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetBulkProductsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBulkProducts>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBulkProducts>>,
          TError,
          Awaited<ReturnType<typeof getBulkProducts>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetBulkProducts<
  TData = Awaited<ReturnType<typeof getBulkProducts>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetBulkProductsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBulkProducts>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Bulk Products
 */

export function useGetBulkProducts<
  TData = Awaited<ReturnType<typeof getBulkProducts>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetBulkProductsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBulkProducts>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetBulkProductsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Route to get an bulk_product by ID.
 * @summary Get Bulk Product
 */
export const getBulkProduct = (bulkProductId: number, signal?: AbortSignal) => {
  return customInstance<BulkProductRead>({
    url: `/api/bulk_product/${bulkProductId}`,
    method: "GET",
    signal,
  });
};

export const getGetBulkProductQueryKey = (bulkProductId?: number) => {
  return ["api", "bulk_product", bulkProductId] as const;
};

export const getGetBulkProductQueryOptions = <
  TData = Awaited<ReturnType<typeof getBulkProduct>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  bulkProductId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBulkProduct>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetBulkProductQueryKey(bulkProductId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getBulkProduct>>> = ({
    signal,
  }) => getBulkProduct(bulkProductId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!bulkProductId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getBulkProduct>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetBulkProductQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBulkProduct>>
>;
export type GetBulkProductQueryError = ErrorType<void | HTTPValidationError>;

export function useGetBulkProduct<
  TData = Awaited<ReturnType<typeof getBulkProduct>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  bulkProductId: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBulkProduct>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBulkProduct>>,
          TError,
          Awaited<ReturnType<typeof getBulkProduct>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetBulkProduct<
  TData = Awaited<ReturnType<typeof getBulkProduct>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  bulkProductId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBulkProduct>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBulkProduct>>,
          TError,
          Awaited<ReturnType<typeof getBulkProduct>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetBulkProduct<
  TData = Awaited<ReturnType<typeof getBulkProduct>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  bulkProductId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBulkProduct>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Bulk Product
 */

export function useGetBulkProduct<
  TData = Awaited<ReturnType<typeof getBulkProduct>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  bulkProductId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBulkProduct>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetBulkProductQueryOptions(bulkProductId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Route to update an bulk_product by ID.
 * @summary Update Bulk Product
 */
export const updateBulkProduct = (
  bulkProductId: number,
  bulkProductCreate: BulkProductCreate,
) => {
  return customInstance<number>({
    url: `/api/bulk_product/${bulkProductId}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: bulkProductCreate,
  });
};

export const getUpdateBulkProductMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateBulkProduct>>,
    TError,
    { bulkProductId: number; data: BulkProductCreate },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateBulkProduct>>,
  TError,
  { bulkProductId: number; data: BulkProductCreate },
  TContext
> => {
  const mutationKey = ["updateBulkProduct"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateBulkProduct>>,
    { bulkProductId: number; data: BulkProductCreate }
  > = (props) => {
    const { bulkProductId, data } = props ?? {};

    return updateBulkProduct(bulkProductId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateBulkProductMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateBulkProduct>>
>;
export type UpdateBulkProductMutationBody = BulkProductCreate;
export type UpdateBulkProductMutationError =
  ErrorType<void | HTTPValidationError>;

/**
 * @summary Update Bulk Product
 */
export const useUpdateBulkProduct = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateBulkProduct>>,
      TError,
      { bulkProductId: number; data: BulkProductCreate },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateBulkProduct>>,
  TError,
  { bulkProductId: number; data: BulkProductCreate },
  TContext
> => {
  const mutationOptions = getUpdateBulkProductMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Route to delete a bulk product by ID.
Checks for dependencies in bulk suborders before deletion.
 * @summary Delete Bulk Product
 */
export const deleteBulkProduct = (bulkProductId: number) => {
  return customInstance<unknown>({
    url: `/api/bulk_product/${bulkProductId}`,
    method: "DELETE",
  });
};

export const getDeleteBulkProductMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteBulkProduct>>,
    TError,
    { bulkProductId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteBulkProduct>>,
  TError,
  { bulkProductId: number },
  TContext
> => {
  const mutationKey = ["deleteBulkProduct"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteBulkProduct>>,
    { bulkProductId: number }
  > = (props) => {
    const { bulkProductId } = props ?? {};

    return deleteBulkProduct(bulkProductId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteBulkProductMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteBulkProduct>>
>;

export type DeleteBulkProductMutationError =
  ErrorType<void | HTTPValidationError>;

/**
 * @summary Delete Bulk Product
 */
export const useDeleteBulkProduct = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteBulkProduct>>,
      TError,
      { bulkProductId: number },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteBulkProduct>>,
  TError,
  { bulkProductId: number },
  TContext
> => {
  const mutationOptions = getDeleteBulkProductMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Returns active bulk reorder schedules containing this bulk product.
 * @summary Get Bulk Product Reorder Usages
 */
export const getBulkProductReorderUsages = (
  bulkProductId: number,
  signal?: AbortSignal,
) => {
  return customInstance<CatalogProductUsageCheck[]>({
    url: `/api/bulk_product/${bulkProductId}/check-reorders`,
    method: "GET",
    signal,
  });
};

export const getGetBulkProductReorderUsagesQueryKey = (
  bulkProductId?: number,
) => {
  return ["api", "bulk_product", bulkProductId, "check-reorders"] as const;
};

export const getGetBulkProductReorderUsagesQueryOptions = <
  TData = Awaited<ReturnType<typeof getBulkProductReorderUsages>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  bulkProductId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBulkProductReorderUsages>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetBulkProductReorderUsagesQueryKey(bulkProductId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBulkProductReorderUsages>>
  > = ({ signal }) => getBulkProductReorderUsages(bulkProductId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!bulkProductId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getBulkProductReorderUsages>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetBulkProductReorderUsagesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBulkProductReorderUsages>>
>;
export type GetBulkProductReorderUsagesQueryError =
  ErrorType<void | HTTPValidationError>;

export function useGetBulkProductReorderUsages<
  TData = Awaited<ReturnType<typeof getBulkProductReorderUsages>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  bulkProductId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBulkProductReorderUsages>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBulkProductReorderUsages>>,
          TError,
          Awaited<ReturnType<typeof getBulkProductReorderUsages>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetBulkProductReorderUsages<
  TData = Awaited<ReturnType<typeof getBulkProductReorderUsages>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  bulkProductId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBulkProductReorderUsages>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBulkProductReorderUsages>>,
          TError,
          Awaited<ReturnType<typeof getBulkProductReorderUsages>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetBulkProductReorderUsages<
  TData = Awaited<ReturnType<typeof getBulkProductReorderUsages>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  bulkProductId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBulkProductReorderUsages>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Bulk Product Reorder Usages
 */

export function useGetBulkProductReorderUsages<
  TData = Awaited<ReturnType<typeof getBulkProductReorderUsages>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  bulkProductId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBulkProductReorderUsages>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetBulkProductReorderUsagesQueryOptions(
    bulkProductId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Check if a bulk product is being used in any bulk suborders.

Parameters:
    - bulk_product_id (int): The ID of the bulk product to check
    - db (AsyncSession): Database session
    - user (AdminUser): Current admin user

Returns:
    - bool: True if product is in use, False otherwise
 * @summary Check Bulk Product Usage
 */
export const checkBulkProductUsage = (
  bulkProductId: number,
  signal?: AbortSignal,
) => {
  return customInstance<boolean>({
    url: `/api/bulk_product/${bulkProductId}/check-usage`,
    method: "GET",
    signal,
  });
};

export const getCheckBulkProductUsageQueryKey = (bulkProductId?: number) => {
  return ["api", "bulk_product", bulkProductId, "check-usage"] as const;
};

export const getCheckBulkProductUsageQueryOptions = <
  TData = Awaited<ReturnType<typeof checkBulkProductUsage>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  bulkProductId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof checkBulkProductUsage>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getCheckBulkProductUsageQueryKey(bulkProductId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof checkBulkProductUsage>>
  > = ({ signal }) => checkBulkProductUsage(bulkProductId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!bulkProductId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof checkBulkProductUsage>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type CheckBulkProductUsageQueryResult = NonNullable<
  Awaited<ReturnType<typeof checkBulkProductUsage>>
>;
export type CheckBulkProductUsageQueryError =
  ErrorType<void | HTTPValidationError>;

export function useCheckBulkProductUsage<
  TData = Awaited<ReturnType<typeof checkBulkProductUsage>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  bulkProductId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof checkBulkProductUsage>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof checkBulkProductUsage>>,
          TError,
          Awaited<ReturnType<typeof checkBulkProductUsage>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useCheckBulkProductUsage<
  TData = Awaited<ReturnType<typeof checkBulkProductUsage>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  bulkProductId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof checkBulkProductUsage>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof checkBulkProductUsage>>,
          TError,
          Awaited<ReturnType<typeof checkBulkProductUsage>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useCheckBulkProductUsage<
  TData = Awaited<ReturnType<typeof checkBulkProductUsage>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  bulkProductId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof checkBulkProductUsage>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Check Bulk Product Usage
 */

export function useCheckBulkProductUsage<
  TData = Awaited<ReturnType<typeof checkBulkProductUsage>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  bulkProductId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof checkBulkProductUsage>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getCheckBulkProductUsageQueryOptions(
    bulkProductId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Restore an archived (soft-deleted) bulk product.
 * @summary Restore Bulk Product
 */
export const restoreBulkProduct = (
  bulkProductId: number,
  signal?: AbortSignal,
) => {
  return customInstance<unknown>({
    url: `/api/bulk_product/restore/${bulkProductId}`,
    method: "POST",
    signal,
  });
};

export const getRestoreBulkProductMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof restoreBulkProduct>>,
    TError,
    { bulkProductId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof restoreBulkProduct>>,
  TError,
  { bulkProductId: number },
  TContext
> => {
  const mutationKey = ["restoreBulkProduct"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof restoreBulkProduct>>,
    { bulkProductId: number }
  > = (props) => {
    const { bulkProductId } = props ?? {};

    return restoreBulkProduct(bulkProductId);
  };

  return { mutationFn, ...mutationOptions };
};

export type RestoreBulkProductMutationResult = NonNullable<
  Awaited<ReturnType<typeof restoreBulkProduct>>
>;

export type RestoreBulkProductMutationError =
  ErrorType<void | HTTPValidationError>;

/**
 * @summary Restore Bulk Product
 */
export const useRestoreBulkProduct = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof restoreBulkProduct>>,
      TError,
      { bulkProductId: number },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof restoreBulkProduct>>,
  TError,
  { bulkProductId: number },
  TContext
> => {
  const mutationOptions = getRestoreBulkProductMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Check if a product exists for a given entity and catalog product combination.
 * @summary Get Bulk Product By Combination
 */
export const getBulkProductByCombination = (
  entityId: number,
  catalogProductId: number,
  signal?: AbortSignal,
) => {
  return customInstance<BulkProduct>({
    url: `/api/bulk_product/lookup/${entityId}/${catalogProductId}`,
    method: "GET",
    signal,
  });
};

export const getGetBulkProductByCombinationQueryKey = (
  entityId?: number,
  catalogProductId?: number,
) => {
  return ["api", "bulk_product", "lookup", entityId, catalogProductId] as const;
};

export const getGetBulkProductByCombinationQueryOptions = <
  TData = Awaited<ReturnType<typeof getBulkProductByCombination>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  entityId: number,
  catalogProductId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBulkProductByCombination>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetBulkProductByCombinationQueryKey(entityId, catalogProductId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBulkProductByCombination>>
  > = ({ signal }) =>
    getBulkProductByCombination(entityId, catalogProductId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(entityId && catalogProductId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getBulkProductByCombination>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetBulkProductByCombinationQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBulkProductByCombination>>
>;
export type GetBulkProductByCombinationQueryError =
  ErrorType<void | HTTPValidationError>;

export function useGetBulkProductByCombination<
  TData = Awaited<ReturnType<typeof getBulkProductByCombination>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  entityId: number,
  catalogProductId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBulkProductByCombination>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBulkProductByCombination>>,
          TError,
          Awaited<ReturnType<typeof getBulkProductByCombination>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetBulkProductByCombination<
  TData = Awaited<ReturnType<typeof getBulkProductByCombination>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  entityId: number,
  catalogProductId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBulkProductByCombination>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBulkProductByCombination>>,
          TError,
          Awaited<ReturnType<typeof getBulkProductByCombination>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetBulkProductByCombination<
  TData = Awaited<ReturnType<typeof getBulkProductByCombination>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  entityId: number,
  catalogProductId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBulkProductByCombination>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Bulk Product By Combination
 */

export function useGetBulkProductByCombination<
  TData = Awaited<ReturnType<typeof getBulkProductByCombination>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  entityId: number,
  catalogProductId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBulkProductByCombination>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetBulkProductByCombinationQueryOptions(
    entityId,
    catalogProductId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
